export default __webpack_public_path__ + "static/media/profileImg8.9a98a2d7.png";